import emptySplitApi from "../utils/rtk";
import { END_POINTS } from "../helpers";

export const authApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    postLogIn: builder.mutation({
      query: (body) => ({
        url: END_POINTS.login,
        method: "POST",
        body,
      }),
    }),
    postSignUp: builder.mutation({
      query: (body) => ({
        url: END_POINTS.signUp,
        method: "POST",
        body,
      }),
    }),
    otpVerify: builder.mutation({
      query: (body) => ({
        url: END_POINTS.verifyOtp,
        method: "POST",
        body,
      }),
    }),

    verifyEmailPhone: builder.mutation({
      query: (body) => ({
        url: END_POINTS.verifyEmailPhone,
        method: "POST",
        body,
      }),
    }),

    resendOtp: builder.mutation({
      query: (body) => ({
        url: END_POINTS.resendOtp,
        method: "POST",
        body,
      }),
    }),

    updateProfile: builder.mutation({
      query: (body) => ({
        url: END_POINTS.profile,
        method: "POST",
        body,
      }),
    }),
    getProfile: builder.query({
      query: ({}) => ({
        url: END_POINTS.getProfile,
        method: "GET",
      }),
    }),

    forgotPassword: builder.mutation({
      query: (body) => ({
        url: END_POINTS.forgotPass,
        method: "POST",
        body,
      }),
    }),
    getLogout: builder.query({
      query: ({}) => ({
        url: END_POINTS.logout,
        method: "GET",
      }),
    }),
    resetPassword: builder.mutation({
      query: (body) => ({
        url: END_POINTS.resetPass,
        method: "POST",
        body,
      }),
    }),
    updateBankDetails: builder.mutation({
      query: (body) => ({
        url: END_POINTS.updateBank,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  usePostLogInMutation,
  usePostSignUpMutation,
  useOtpVerifyMutation,
  useVerifyEmailPhoneMutation,
  useResendOtpMutation,
  useUpdateProfileMutation,
  useLazyGetProfileQuery,
  useForgotPasswordMutation,
  useLazyGetLogoutQuery,
  useResetPasswordMutation,
  useUpdateBankDetailsMutation,
} = authApi;
